import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../../styles/variables';
import { device } from '../../../styles/devices';

export const MileageFilterFrame = styled.div`
  padding: 24px;
`;

export const MileageFilterWrapper = styled.div`
  display: flex;
  font-family: Audi Type;
  flex-direction: column;
  gap: 24px;
  // overwrite label option of Select audi ui react library component
  .hasValue {
    label:not(:focus-within) {
      animation-name: none;
    }
  }
`;
